export const extensionRoutes = [  {
    path: 'extensions/product-sales-metrics',
    loadChildren: () => import('./extensions/product-sales-metrics-ui/routes'),
  }];
